@use "~theme/typography";
@use "~theme/breakpoints";

.noAvailabilityContainer{
    padding: 10px 0px;
    @include breakpoints.desktop {
        margin-left: -40px;
        padding-top: 0px;
    }
    a {
        width: 85%;
    }
    button {
        width:85%;
        @include breakpoints.desktop {
            width: 38%;
        }
    }
}

.slots {
    margin: 18px 10px 5px;
    display: flex;
    flex-flow: row wrap;
    width: 88px;
    float: left;
    border-radius: 10px;
}

.button {
    flex-grow: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #FFFFFF;    
    background: var(--blue-01);
    border-radius: 4px;
    margin: 5px auto;
    width: 100%;
    @include breakpoints.desktop {
        width: 38%;
        height: 36px;
        min-height: 36px;
        font-size: 12px;
    }
    span {
        @include breakpoints.desktop {
            height: 36px;
            min-height: 36px;
        }
    }
  }

.button:hover {
    background-color: var(--blue-01);
    border-color: var(--blue-01);
}

.button:active, .button:focus {
    box-shadow: none;
}
.divLabel {
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    text-align: center;
    letter-spacing: 0.02em;
    padding: 0 4%;

    @include breakpoints.desktop {
        padding: 0px;
    }
}

.timeIcon {
    float:left;
    width: 8%;
    padding-top: 10px;
    img {
        width: 20px;
        @include breakpoints.desktop {
            width: auto;
        }
    }

    .eveningIcon {
        width: 10px;
        @include breakpoints.desktop {
            width: auto;
        }
    }
}

.timeSlotsContainer {
    float:left;
    width: 90%;
}

.officeCall {
    text-align: center;
}

.scheduleExam {
    width: 100%;
    margin: 20px 0px 0px 0px;
    font-size: 20px;
    background-color: var(--blue-01);
}

.scheduleExam:disabled {
    background-color: var(--gray-01);
}